import { API, graphqlOperation } from "aws-amplify";

import { getUserByEmailQuery } from "./graphql/queries";

const getUserByEmail = (email) =>
  API.graphql(graphqlOperation(getUserByEmailQuery, { email }));

export default getUserByEmail;
